











import Vue from 'vue';

export default Vue.extend({
  name: 'CloseButton',
  methods: {
    close(cmd: string) {
      if (cmd === 'quit') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        open(location, '_self').close();
      }
      return false;
    },
  },
});
